import React, { Component } from 'react'
import "./score_info.scss"
import cur_icon_circle_sel from "../../../../../../images/emotion_analysis/cur_icon_circle_sel.png"
import cur_icon_circle_nor from "../../../../../../images/emotion_analysis/cur_icon_circle_nor.png"
export default class score_info extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: 'nps_info',               //从哪个页面进入的
            dataList: {},
            min_value: 0,
            max_value: 5,
            min_name: "",
            max_name: "",
        }
    }
    static getDerivedStateFromProps(props, state) {
        if (JSON.stringify(props.dataList) !== JSON.stringify(state.dataList_prev)) {
            return {
                needRefresh: true,
                dataList: props.dataList || state.dataList,
                dataList_prev: props.dataList,
                min_value: parseInt(props.dataList.min_value),
                max_value: parseInt(props.dataList.max_value) || "",
                min_name: props.dataList.min_name || "",
                max_name: props.dataList.max_name || "",
            }
        }
        return null;
    }
    componentDidMount() {
        this._isMounted = true
        // if (this._isMounted) {
        //     this.toInitChart()
        //     setTimeout(() => {
        //         this.toInitFoot()
        //     })
        // }
    }
    componentDidUpdate() {
        if (this._isMounted && this.state.needRefresh) {
            // this.toInitChart()
            // setTimeout(() => {
            //     this.toInitFoot()
            // })
            this.setState({
                needRefresh: false
            })
        }
    }
    componentWillUnmount() {
        this._isMounted = false;
        this.setState = () => { }
    }
    render() {
        let items = [];
        for (let i = this.state.min_value; i <= this.state.max_value; i++) {
            if (i === this.state.min_value) {
                items.push(<div className="grade_item" key={i}>
                    <img src={cur_icon_circle_sel} alt="" />
                    <span>{i}</span>
                </div>);
            } else {
                items.push(<div className="grade_item" key={i}>
                    <img src={cur_icon_circle_nor} alt="" />
                    <span>{i}</span>
                </div>);
            }

        }
        return (
            <div className="score-info-container">
                <div className='draw_slip'>
                    <div className="draw_slip_index">
                        {
                            items
                        }
                    </div>
                    <div className='draw-slip-foot'>
                        <div className='draw-slip-foot-name'>{this.state.min_name}</div>
                        <div className='draw-slip-foot-name'>{this.state.max_name}</div>
                    </div>
                </div>
            </div>
        )
    }
}
